import i18next from 'i18next';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';

import { I18nextProvider } from 'react-i18next';
import App from './App';

import './i18n';

import './common/styles/main.less';
import './index.css';

const container = document.querySelector('#root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- This is defined always in `index.html`
const root = createRoot(container!);
root.render(
  <I18nextProvider i18n={i18next}>
    <App />
  </I18nextProvider>,
);

if (import.meta.env.PROD) {
  ReactGA.initialize([
    {
      gaOptions: {
        app_version: String(import.meta.env.VITE_APP_VERSION),
        environment: String(import.meta.env.VITE_APP_GOOGLE_TRACKING_ENVIRONMENT),
        transport: 'beacon',
        wla_name: String(import.meta.env.VITE_APP_TITLE),
      },
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      trackingId: import.meta.env.VITE_APP_GOOGLE_TRACKING_ID,
    },
  ]);

  ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
}
